import React from 'react';

export default class ShFloorplans extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidMount() {
    this.ref.current.floorplans = this.props.listing.floorplans;
  }

  render() {
    return (
      <sh-floorplans ref={this.ref}></sh-floorplans>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/listing-detail/sh-wrappers/sh-floorplans.js